module.exports = __webpack_public_path__ + "img/sharp-example10.79d69df0.jpg";